// src/components/Contact.js
import React from 'react';

const Contact = () => {
  return (
    <section className="section contact">
      <h2>Contact</h2>
      <p>If you'd like to get in touch, feel free to reach out to me through the following channels:</p>
      <ul>
        <li><strong>Email:</strong> <a href="mailto:asaniket28@gmail.com">asaniket28@gmail.com</a></li>
        <li><strong>Phone:</strong> +91-6387511835</li>
        <li><strong>Location:</strong> Lucknow, Uttar Pradesh, India</li>
        <li><strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/aniket-srivastava-619475223/]">linkedin.com/in/[your-linkedin]</a></li>
        <li><strong>GitHub:</strong> <a href="https://github.com/aniketsrivastava89">github.com/[your-github]</a></li>
      </ul>
      <p>I'm always open to discussing new projects, collaboration opportunities, or just chatting about tech!</p>
    </section>
  );
};

export default Contact;
